import { apiCall, apiCallAdmin } from "../../service/api-service.js";

// 1. Location
export const getLocationApi = async (term) => 
  apiCallAdmin("get", "get_location", null, { params: { term } });

// 2. Department
export const getDepartmentApi = async (term) => 
  apiCallAdmin("get", "get_department", null, { params: { term } });

// 3. Type
export const getTypeApi = async (term) => 
  apiCall("get", "getAssettype", null, { params: { term } });

// 4. Report Type
export const getReportTypeApi = async (term) => 
  apiCallAdmin("get", "get_report_type", null, { params: { term } });

// 5. Status
export const getStatusApi = async (term) => 
  apiCallAdmin("get", "get_status", null, { params: { term } });

// 6. Managed By
export const getManagedByApi = async (term) => 
  apiCallAdmin("get", "get_employee", null, { params: { term } });

// 7. Used By
export const getUsedByApi = async (term) => 
  apiCallAdmin("get", "get_employee", null, { params: { term } });

//8. Report
export const getQuickReportApi = async () => 
  apiCall("get", "report/get_quick_report");

//9. Export Quick Report
export const exportQuickReportApi = async (reportType, fromDate, toDate) => 
  apiCall("post", `report/${reportType}`, {
    from_date: fromDate,
    to_date: toDate,
  });

//10. Download Custom Report
export const downloadCustomReportApi = async (reportType, data) => 
  apiCall("post", reportType, data);

